import React from "react";

const Othercomponent = (props) => {
  return <React.Fragment>{props?.children}</React.Fragment>;
};

export default Othercomponent;
